export default __webpack_public_path__ + "static/media/harmony-one.9aa64a42.svg";